<template>
  <div>
    <!--<div>
      <Row :gutter="10">
        <Button type="primary" @click="toObd">小云-OBD</Button>
      </Row>
    </div>-->
    <div>
      <Row :gutter="10">
        <!-- 本月累计充值 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-wallet" size="20" color="#2d8cf0" />
              <span class="card-title">本月累计充值</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.month_charge_amount || 0 }} 元</div>
            </div>
          </Card>
        </Col>

        <!-- 上次充值金额 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-history" size="20" color="#7367f0" />
              <span class="card-title">上次充值</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.latest_charge || 0 }} 元</div>
            </div>
          </Card>
        </Col>

        <!-- 当前剩余/燃气余额 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px" v-if="!isSpecialCompany">
            <div class="card-header">
              <Icon type="ios-piggy-bank" size="20" color="#19be6b" />
              <span class="card-title">当前剩余</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.can_use_balance || 0 }} {{ info.balance_unit }}</div>
            </div>
          </Card>
          <Card class="dashboard-card" style="margin-top: 10px" v-else>
            <div class="card-header">
              <Icon type="md-flame" size="20" color="#ff9900" />
              <span class="card-title">燃气余额</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.lng_balance != null ? info.lng_balance + ' ' + (info.balance_unit || '') : '-' }}</div>
            </div>
          </Card>
        </Col>

        <!-- 车队剩余总量/柴油余额 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px" v-if="!isSpecialCompany">
            <div class="card-header">
              <Icon type="ios-car" size="20" color="#00c5dc" />
              <span class="card-title">车队剩余</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.can_use_balance || 0 }} {{ info.balance_unit }}</div>
            </div>
          </Card>
          <Card class="dashboard-card" style="margin-top: 10px" v-else>
            <div class="card-header">
              <Icon type="md-fuel" size="20" color="#ed4014" />
              <span class="card-title">柴油余额</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.oil_balance != null ? info.oil_balance + ' ' + (info.balance_unit || '') : '-' }}</div>
            </div>
          </Card>
        </Col>

        <!-- 车队卡可用数量 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-card" size="20" color="#faad14" />
              <span class="card-title">车队卡可用</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.card_balance || 0 }} {{info.balance_unit}}</div>
            </div>
          </Card>
        </Col>

        <!-- 可分配数量 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-share-alt" size="20" color="#52c41a" />
              <span class="card-title">可分配</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.balance || 0 }} {{info.balance_unit}}</div>
            </div>
          </Card>
        </Col>

        <!-- 司机人数 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-people" size="20" color="#722ed1" />
              <span class="card-title">司机人数</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.driver_num || 0 }}</div>
            </div>
          </Card>
        </Col>

        <!-- 昨日加油总量 -->
        <Col span="4">
          <Card class="dashboard-card warning-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-calendar" size="20" color="#ff9900" />
              <span class="card-title">昨日加油</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.yesterday_litre || 0 }} L</div>
              <div class="sub-info">
                <span class="label">金额：</span>
                <span class="value yesterday-amount">{{ info.yesterday_amount || 0 }} 元</span>
              </div>
            </div>
          </Card>
        </Col>

        <!-- 今日加油总量 -->
        <Col span="4">
          <Card class="dashboard-card success-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="md-trending-up" size="20" color="#19be6b" />
              <span class="card-title">今日加油</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.today_litre || 0 }} L</div>
              <div class="sub-info">
                <span class="label">金额：</span>
                <span class="value today-amount">{{ info.today_amount || 0 }} 元</span>
                <span v-if="info.litre_growth_rate !== undefined" class="growth" :class="getGrowthClass(info.litre_growth_rate)">
                  <Icon :type="info.litre_growth_rate >= 0 ? 'md-arrow-round-up' : 'md-arrow-round-down'" />
                  {{ Math.abs(info.litre_growth_rate || 0) }}%
                </span>
              </div>
            </div>
          </Card>
        </Col>

        <!-- 今日加油笔数 -->
        <Col span="4">
          <Card class="dashboard-card" style="margin-top: 10px">
            <div class="card-header">
              <Icon type="ios-document" size="20" color="#13c2c2" />
              <span class="card-title">今日笔数</span>
            </div>
            <div class="card-content">
              <div class="main-value">{{ info.today_order_amount || 0 }}</div>
              <div class="sub-info">
                <span class="label">昨日：</span>
                <span class="value">{{ info.yesterday_order_num || 0 }}</span>
                <span v-if="info.order_growth_rate !== undefined" class="growth" :class="getGrowthClass(info.order_growth_rate)">
                  <Icon :type="info.order_growth_rate >= 0 ? 'md-arrow-round-up' : 'md-arrow-round-down'" />
                  {{ Math.abs(info.order_growth_rate || 0) }}%
                </span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>

    <div style="margin-top: 10px">
      <Card title="可加油站点">
        <Row :gutter="10">
          <Col span="16">
            <div>
              <Form inline :label-width="100" @keydown.native.enter.prevent>
                <FormItem prop="key" label="地址:">
                  <Input v-model="mapAddress"  placeholder="" style="width:400px"></Input>
                </FormItem>
                <FormItem>
                  <Button type="primary" size="small" @click="setCenterByName">搜索</Button>
                  <Button type="default" size="small" style="margin-left: 8px" @click="manualRefreshStations">手动刷新</Button>
                  <FormItem class="only-mine-item">
                    <Checkbox id="demo" v-model="onlyMine" @on-change="handleOnlyMineChange">仅显示我的</CheckBox>
                  </FormItem>
                </FormItem>





              </Form>

            </div>
            <div id="mapContainer" style="width:100%;height: 100%"></div>
          </Col>
          <Col span="8">
            <pageTable
                    :tableTitle="tableColumn"
                    :searchData="searchData"
                    :showSearchForm="true"
                  :showPage="true"
                  :countOnFirstPageOnly="true"
                  :defaultPageSize="20"
                  :pageSizeOptions="[20,50,100]"
                    tableApi="admin/my_company/getCompanyStation"
            >
              <template slot="searchFormItem">
                <FormItem label="站点名称">
                  <Input v-model="searchData.gas_name" placeholder="站点名称" style="width:180px"></Input>
                </FormItem>
                <FormItem label="站点类型">
                  <Select v-model="searchData.station_type" style="width:140px" clearable>
                    <Option value="">全部</Option>
                    <Option value="oil_station">柴油</Option>
                    <Option value="lng_station">LNG</Option>
                  </Select>
                </FormItem>
              </template>
              <template slot="otherBtn">
                <FormItem v-if="canExport">
                  <Button type="primary" size="small" @click="exportStations">导出</Button>
                </FormItem>
              </template>
            </pageTable>
          </Col>
        </Row>
      </Card>
    </div>
  </div>


</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import AMapLoader from '@amap/amap-jsapi-loader';
  export default {
    name: "homeCompany",
    components:{pageTable},
    props:{
      homeInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data(){
      return {
        searchData:{},
        info:{},
        canExportFlag:false,
        tableColumn:[
          {title: '油站名称',key: 'gas_name',align: "center"},
          {title: '价格',key: 'price',align: "center"},
        ],
        mapAddress:'',
        onlyMine:true,
        geocoder: null,
        centerMarker:false,
        stationRadiusKm: 200,
        stationMarkers: [],
        mapMoveTimer: null,
        mapMoveHandler: null,
        allStationCache: [],
        stationCacheLoaded: false,
        stationFetchPromise: null,
        stationCacheExpireAt: 0,
        stationCacheTtlMs: 30 * 60 * 1000,
      }
    },
    computed: {
      // 当 info.company_id 在此列表中时，显示燃气/柴油余额卡片
      isSpecialCompany(){
        const list = [509,514,515,516,517,691,692,694];
        return this.info && list.includes(Number(this.info.company_id));
      }
      ,
      canExport(){
        return !!this.canExportFlag;
      }
    },
    methods:{
      applyHomeInfo(data = {}){
        this.info = data || {};
        if (this.info && this.info.company_id !== undefined) {
          this.searchData.company_id = this.info.company_id;
        }
      },
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/count/home')
        this.applyHomeInfo(res.data || {});
      },
      async loadExportPermission(){
        // 优先从 store 中读取 account 或 mobile
        let user = (this.$store && this.$store.state && this.$store.state.user) ? this.$store.state.user.userInfo : {};
        // 如果 store 中没有完整信息，尝试从 sessionStorage 读取
        if ((!user || !user.uid) && window && window.sessionStorage){
          try{
            const s = window.sessionStorage.getItem('userInfo');
            if (s){
              const su = JSON.parse(s);
              user = Object.assign({}, user || {}, su || {});
            }
          }catch(e){
            // ignore
          }
        }

        if (user && (String(user.account) === '15501376646' || String(user.mobile) === '15501376646' || String(user.account) === '17609162259' || String(user.mobile) === '17609162259')){
          this.canExportFlag = true;
          return;
        }

        // 否则拉取本公司管理员列表，匹配 uid（后端返回管理员含 account 字段）
        let res = await this.$commonFun.postProxy('admin/my_company/getAdminUser')
        if (res && res.data && Array.isArray(res.data)){
          const meUid = user && user.uid ? Number(user.uid) : null;
          let me = null;
          if (meUid !== null){
            me = res.data.find(i=>Number(i.uid) === meUid);
          }
          if (me && (String(me.account) === '15501376646' || String(me.mobile) === '15501376646' || String(me.account) === '17609162259' || String(me.mobile) === '17609162259')){
            this.canExportFlag = true;
          }else{
            this.canExportFlag = false;
          }
        }
      },
      async toObd(){
        let res = await this.$commonFun.postProxy('admin/my_company/getMyCompanyInfo')
        this.$commonFun.dealApiResult(res,()=>{
          if (res.data.obd_account && res.data.obd_pwd){
            window.open(`http://team.xyobd.com/kst/#/login?mobile=${res.data.obd_account}&password=${res.data.obd_pwd}&intoType=KST`)
          }else{
            this.$commonFun.errorTip('尚未配置OBD账号密码，请联系管理员')
          }
        })
      },
      async initMap(){
        window._AMapSecurityConfig = {
          securityJsCode: "20341665b1257613258851e2f4d03f9b",
        };

        AMapLoader.load({
          key:"c3219f1ed0f4493a4f3ca6ead5e51d37",     // 申请好的Web端开发者Key，首次调用 load 时必填
          version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins:['AMap.Geocoder'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap)=>{
          this.map = new AMap.Map("mapContainer",{  //设置地图容器id
            // viewMode:"3D",    //是否为3D地图模式
            zoom:10,           //初始化地图级别
            center:[104.07,30.57], //初始化地图中心点位置
          });
          this.AMap = AMap;

          this.geocoder = new AMap.Geocoder({});
          this.mapMoveHandler = () => {
            this.handleMapMoveEnd();
          };
          this.map.on('moveend', this.mapMoveHandler);
          this.getStations()
        }).catch(e=>{
          console.log(e);
        })


      },
      async ensureStationCache(forceReload = false){
        const cacheValid = this.stationCacheLoaded && Date.now() < this.stationCacheExpireAt;
        if (!forceReload && cacheValid) {
          return true;
        }
        if (this.stationFetchPromise) {
          await this.stationFetchPromise;
          return true;
        }
        const params = { onlyMine: false };
        this.stationFetchPromise = this.$commonFun.postProxy('admin/my_company/getMapStations', params)
          .then((stations) => {
            this.allStationCache = Array.isArray(stations && stations.data) ? stations.data : [];
            this.stationCacheLoaded = true;
            this.stationCacheExpireAt = Date.now() + this.stationCacheTtlMs;
          })
          .catch(() => {
            this.allStationCache = [];
            this.stationCacheLoaded = false;
            this.stationCacheExpireAt = 0;
          })
          .finally(() => {
            this.stationFetchPromise = null;
          });
        await this.stationFetchPromise;
        return true;
      },
      async manualRefreshStations(){
        await this.getStations({ forceReload: true });
        if (this.$Message && this.$Message.success) {
          this.$Message.success('站点数据已刷新');
        }
      },
      isMineStation(item){
        const icon = String(item && item.icon ? item.icon : '');
        return icon.indexOf('/oil_station.png') !== -1;
      },
      renderStationsByCenter(){
        //先清空所有的
        if (this.map && this.stationMarkers.length) {
          this.map.remove(this.stationMarkers);
        }
        this.stationMarkers = [];

        const center = this.map && this.map.getCenter ? this.map.getCenter() : null;
        let centerLng = center && center.lng ? Number(center.lng) : null;
        let centerLat = center && center.lat ? Number(center.lat) : null;
        if ((centerLng === null || centerLat === null) && this.map && this.map.getCenter){
          const fallbackCenter = this.map.getCenter();
          centerLng = fallbackCenter && fallbackCenter.lng ? Number(fallbackCenter.lng) : 104.07;
          centerLat = fallbackCenter && fallbackCenter.lat ? Number(fallbackCenter.lat) : 30.57;
        }

        this.allStationCache.forEach((item)=>{
          if (this.onlyMine && !this.isMineStation(item)) {
            return;
          }
          if (!this.isWithinRadius(centerLng, centerLat, Number(item.longitude), Number(item.latitude), this.stationRadiusKm)) {
            return;
          }
          let marker = new this.AMap.Marker({
            position: [item.longitude, item.latitude],
            zIndex: 16,
            anchor: 'bottom-center',
            content: this.buildStationMarkerCard(item),
          });
          this.stationMarkers.push(marker)
        })
        if (this.stationMarkers.length) {
          this.map.add(this.stationMarkers);
        }
      },
      async getStations(options = {}){
        const forceReload = !!(options && options.forceReload);
        await this.ensureStationCache(forceReload);
        this.renderStationsByCenter();
      },
      handleMapMoveEnd(){
        if (this.mapMoveTimer) {
          clearTimeout(this.mapMoveTimer);
        }
        this.mapMoveTimer = setTimeout(() => {
          this.renderStationsByCenter();
        }, 780);
      },
      escapeHtml(text){
        const source = text === null || text === undefined ? '' : String(text);
        return source
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      },
      buildStationMarkerCard(item){
        const title = this.escapeHtml(item.gas_name || '');
        const priceText = this.escapeHtml(item.price === null || item.price === undefined || item.price === '' ? '-' : item.price);
        const iconUrl = this.escapeHtml(item.icon || 'https://oil.scsasy.com/static/images/icon/stationGrey.png');
        return `<div style="display:flex;flex-direction:column;align-items:center;transform:translateY(4px);">
          <div style="min-width:210px;max-width:260px;background:#ffffff;border:1px solid #dfe6ef;border-radius:10px;box-shadow:0 8px 20px rgba(31,45,61,0.14);padding:8px 10px;line-height:1.35;">
            <div style="font-size:13px;font-weight:700;color:#1f2d3d;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${title}</div>
            <div style="margin-top:6px;font-size:14px;font-weight:700;color:#ff7a00;">￥ ${priceText}</div>
          </div>
          <div style="width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:9px solid #ffffff;filter:drop-shadow(0 2px 2px rgba(31,45,61,0.16));margin-top:-1px;"></div>
          <img src="${iconUrl}" style="width:30px;height:30px;margin-top:2px;" />
        </div>`;
      },
      isWithinRadius(centerLng, centerLat, pointLng, pointLat, radiusKm = 200){
        if ([centerLng, centerLat, pointLng, pointLat].some(v => Number.isNaN(v) || v === null || v === undefined)) {
          return false;
        }
        const toRad = (deg) => deg * Math.PI / 180;
        const earthRadiusKm = 6371;
        const dLat = toRad(pointLat - centerLat);
        const dLng = toRad(pointLng - centerLng);
        const lat1 = toRad(centerLat);
        const lat2 = toRad(pointLat);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
          + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = earthRadiusKm * c;
        return distance <= radiusKm;
      },
      handleOnlyMineChange(){
        this.renderStationsByCenter();
      },
      getGrowthClass(rate){
        if (rate > 0) return 'positive';
        if (rate < 0) return 'negative';
        return 'neutral';
      },
      async exportStations(){
        // 使用当前搜索条件发起导出请求
        let params = Object.assign({}, this.searchData);
        params.export = 1;
        let res = await this.$commonFun.postProxy('admin/my_company/getCompanyStation', params)
        if (!res || !res.data || !res.data.length){
          this.$commonFun.errorTip('无可导出的数据');
          return;
        }
        // res.data 为二维数组，第一行为表头
        const rows = res.data;
        const csvContent = rows.map(r => r.map(cell => {
          if (cell === null || cell === undefined) return '';
          const s = String(cell).replace(/"/g, '""');
          return '"' + s + '"';
        }).join(',')).join('\r\n');
        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const fileName = 'stations_export_' + (new Date()).toISOString().slice(0,10) + '.csv';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      },
      setCenterByName() {
        // 使用Geocoder根据地址查询经纬度
        console.log(this.mapAddress)
        if (!this.mapAddress) return;
        this.geocoder.getLocation(this.mapAddress, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            // 成功获取到地理位置信息
            const lnglat = result.geocodes[0].location;
            // 更新地图中心点
            this.map.setCenter([lnglat.lng, lnglat.lat]);
            if (this.centerMarker){
              this.map.remove(this.centerMarker);
              this.centerMarker = false;
            }

            this.centerMarker = new this.AMap.Marker({
              position: [lnglat.lng, lnglat.lat],
              zIndex: 18,
              // size: [60, 60],
              icon: new this.AMap.Icon({
                size: new this.AMap.Size(30, 30), // 设置图标尺寸
                image: 'https://oil.scsasy.com/static/images/icon/map.png', // 替换为实际的图标URL
                imageSize: new this.AMap.Size(30, 30), // 如果图标原始尺寸与所需尺寸不同，可以重新设置
                anchor: 'center' // 图标锚点，默认为中心
              }),
            });

            this.map.add(this.centerMarker);
          } else {
            console.error('无法获取该地址的位置信息');
          }
        });
      }
    },
    beforeDestroy() {
      if (this.mapMoveTimer) {
        clearTimeout(this.mapMoveTimer);
        this.mapMoveTimer = null;
      }
      if (this.map && this.mapMoveHandler) {
        this.map.off('moveend', this.mapMoveHandler);
      }
    },
    mounted(){
      this.initMap();
    },
    created() {
      if (this.homeInfo && Object.keys(this.homeInfo).length) {
        this.applyHomeInfo(this.homeInfo);
      } else {
        this.getInfo();
      }
      this.loadExportPermission()
    },
    watch: {
      homeInfo: {
        handler(newVal) {
          if (newVal && Object.keys(newVal).length) {
            this.applyHomeInfo(newVal);
          }
        },
        deep: true,
      },
    }
  }
</script>

<style scoped lang="less">
.ivu-form-item-content{
  margin-left: 8px!important;
}

#demo{
  margin-left: 8px!important;
}

.only-mine-item{
  margin-left: 10px;
  display: inline-block;
}

.dashboard-card {
  margin-bottom: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
  
  /deep/ .ivu-card-body {
    padding: 16px;
  }
  
  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    i {
      margin-right: 8px;
    }
    
    .card-title {
      font-size: 13px;
      color: #808695;
      font-weight: 500;
    }
  }
  
  .card-content {
    .main-value {
      font-size: 24px;
      font-weight: 700;
      color: #17233d;
      margin-bottom: 8px;
      line-height: 1.2;
    }
    
    .sub-info {
      font-size: 12px;
      color: #808695;
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      
      .label {
        color: #808695;
      }
      
      .value {
        color: #515a6e;
        font-weight: 500;
        
        &.yesterday-amount {
          color: #ff9900;
          font-weight: 600;
        }
        
        &.today-amount {
          color: #19be6b;
          font-weight: 600;
        }
      }
      
      .growth {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        font-weight: 600;
        font-size: 11px;
        padding: 2px 6px;
        border-radius: 4px;
        
        &.positive {
          color: #19be6b;
          background-color: rgba(25, 190, 107, 0.1);
        }
        
        &.negative {
          color: #ed4014;
          background-color: rgba(237, 64, 20, 0.1);
        }
        
        &.neutral {
          color: #808695;
          background-color: rgba(128, 134, 149, 0.1);
        }
      }
    }
  }
  
  // 特殊卡片样式
  &.warning-card {
    .card-header i {
      color: #ff9900;
    }
    .main-value {
      color: #ff9900;
    }
  }
  
  &.success-card {
    .card-header i {
      color: #19be6b;
    }
    .main-value {
      color: #19be6b;
    }
  }
}
</style>
